@if (layout() === "filter") {
  <app-filter-product-search
    [label]="isArabic() ? 'المندوب' : 'Representative'"
    [placeholder]="isArabic() ? 'ابحث باسم المندوب...' : 'Search by representative name'"
    [loading]="loadingRepresentative()"
    [error]="errorRepresentative() ? (isArabic() ? 'حدث خطأ' : 'Error fetching results') : ''"
    [results]="filterResults()"
    [(searchTerm)]="filterSearchTerm"
    [(showDropdown)]="filterShowDropdown"
    (searchChange)="onFilterSearch($event)"
    (selectItem)="onFilterSelect($event)"></app-filter-product-search>
} @else {
<div class="relative flex flex-col gap-2" [formGroup]="pharmacyForm()">
  <label for="representativeName" class="cursor-pointer text-sm font-medium" i18n="@@adminCreatePharmacyFormRepresentative">
    Pharmacy Representative
    <span class="text-red-600">*</span>
  </label>

  <input
    id="representativeName"
    type="text"
    [value]="selectedRepresentativeName()"
    formControlName="representative"
    placeholder="Search by pharmacy representative name"
    i18n-placeholder="@@adminCreatePharmacyFormRepresentativePlaceholder"
    class="w-full rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-sm transition-colors placeholder:text-gray-400 focus:bg-white focus:outline-none"
    [class]="{
      'border-gray-200 hover:border-black focus:border-black': !(
        pharmacyForm().get('representative')?.invalid && pharmacyForm().get('representative')?.touched
      ),
      'border-red-500 bg-red-50 hover:border-red-600 focus:border-red-600':
        pharmacyForm().get('representative')?.invalid && pharmacyForm().get('representative')?.touched,
    }" />

  @if (loadingRepresentative()) {
    <div class="max-h-52 overflow-y-auto rounded-md border border-gray-200 bg-white py-6 shadow-lg">
      <app-loading />
    </div>
  }

  @if (errorRepresentative()) {
    <div class="max-h-52 overflow-y-auto rounded-md border border-gray-200 bg-white shadow-lg">
      <app-error [apiError]="isArabic() ? 'حدث بعض الخطأ' : 'Some error occurred'" />
    </div>
  }

  @if (showRepresentativeDropdown() && representativeResults().length > 0 && !loadingRepresentative()) {
    <div class="max-h-52 overflow-y-auto rounded-md border border-gray-200 bg-white shadow-lg">
      @for (item of representativeResults(); track item.id) {
        <button
          type="button"
          (click)="onSelectRepresentative(item.id.toString(), item.fullName)"
          class="block w-full cursor-pointer px-4 py-2 text-start text-sm transition-colors hover:bg-gray-50">
          {{ item.fullName }}
        </button>
      }
    </div>
  }

  @if (showRepresentativeDropdown() && representativeResults().length === 0) {
    <div class="max-h-52 overflow-y-auto rounded-md border border-gray-200 bg-white shadow-lg">
      <p
        i18n="@@noRepresentativeData"
        class="mx-auto flex w-full justify-center border-b border-gray-50 px-4 py-2 text-center text-start text-sm transition-colors last:border-0 hover:bg-gray-50">
        No Representative matches this name
      </p>
    </div>
  }

  @if (pharmacyForm().get("representative")?.invalid && pharmacyForm().get("representative")?.touched) {
    <span class="text-xs text-red-600">
      @if (pharmacyForm().get("representative")?.errors?.["required"]) {
        <span i18n="@@adminCreatePharmacyFormErrorRepresentativeNameRequired">Pharmacy representative name is required</span>
      }
    </span>
  }
</div>
}
